<template>
  <div class="process-item d-flex flex-column" v-on:click="activeProcessItem">
    <el-button :type="isActive ? 'primary' : null"
     :disabled="!processInfo.F_CreateDate" plain round>{{
      processInfo.F_NodeName
    }}</el-button>
    <div class="process-time text-warning" style="margin-top:4px;">
      {{ processInfo.F_CreateDate ? processInfo.F_CreateDate : "&nbsp;" }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'process-item',
  props: {
    processInfo: {
      default() {
        return {
          name: '新告警',
          order: 0,
          time: '2020-12-24 15:38:59',
          status: 1,
          timeSpan: 0,
        };
      },
      type: Object,
    },
    isActive: {
      default: 1,
      type: [Number, Boolean],
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    activeProcessItem() {
      this.$emit('activeProcess');
    },
  },
};
</script>
<style scoped>
.step-name {
  cursor: pointer;
  border: solid 1px darkblue;
  box-shadow: 0 0 2rem rgb(14, 101, 192) inset;
}
.process-time {
  font-size: 12px;
  line-height: 12px;
  height: 12px;
}
.step-name.active {
  font-size: 0.9rem;
}
</style>
